import AutoBind from 'auto-bind'
import Prefix from 'prefix'

export default class {
  constructor ({ element, elements }) {
    AutoBind(this)

    const { animationDelay, animationTarget } = element.dataset

    this.delay = animationDelay

    this.element = element
    this.elements = elements

    this.target = animationTarget ? element.closest(animationTarget) : element
    this.transformPrefix = Prefix('transform')

    this.isVisible = false
    this.reset = true

    if ('IntersectionObserver' in window) {
      this.createObserver()

      this.animateOut()
    } else {
      this.animateIn()
    }
  }

  createObserver () {
    // Store the observer itself, not .observe()'s return value (void) —
    // needed so destroy() can actually disconnect it.
    this.observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!this.isVisible && entry.isIntersecting) {
          this.animateIn()
        } else {
           if (this.reset) {
            this.animateOut()
          }
        }
      })
    })
    this.observer.observe(this.target)
  }

  animateIn () {
    this.isVisible = true
  }

  animateOut () {
    this.isVisible = false
  }

  destroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
